export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8313.b05e5da6.jpg";